
export function Colors(mode) {

    return {
        background: mode ? 'bg-black' : 'bg-primary-subtle',
        headingColor: mode ? 'text-info' : 'text-primary',
        textColor: mode ? 'text-white' : 'text-black',
    }
}
